import React, { useState } from 'react';

export default function Contacto() {
  const [form, setForm] = useState({ nombre: '', email: '', mensaje: '' });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <section className="section page-section contact-page">
      <div className="section-header">
        <h1>Contáctanos</h1>
        <p>¿Tienes dudas o comentarios? Escríbenos, estamos para ayudarte.</p>
      </div>
      <div className="contact-grid">
        <form onSubmit={handleSubmit} className="contact-form">
          {sent ? (
            <p className="success-message">¡Gracias por tu mensaje! Te responderemos pronto.</p>
          ) : (
            <>
              <label>
                Nombre
                <input required value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} />
              </label>
              <label>
                Correo electrónico
                <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              </label>
              <label>
                Mensaje
                <textarea rows={5} required value={form.mensaje} onChange={(e) => setForm({ ...form, mensaje: e.target.value })} />
              </label>
              <button type="submit" className="btn btn-primary">Enviar mensaje</button>
            </>
          )}
        </form>
        <div className="contact-info">
          <h3>Información de contacto</h3>
          <p>📧 hola@misxv.com.mx</p>
          <p>📞 +52 55 0000 0000</p>
          <p>📍 Ciudad de México, México</p>
        </div>
      </div>
    </section>
  );
}
